import { collection, doc, getDoc, onSnapshot, query, where, orderBy } from "firebase/firestore";
import { firestore } from "../firebase-config";
import { ids_firebase } from "../content-site";

const veiculosCollection = (idLoja) =>
    collection(doc(collection(firestore, "revenda"), idLoja), "veiculos");

const veiculosQuery = (idLoja) => query(
    veiculosCollection(idLoja),
    where("veremovido", "==", 0),
    where("vevendido", "==", 0),
    orderBy("updated_at", "desc")
);

const normalizarSnapshot = (snapshot, idLoja) => snapshot.docs.map((item) => ({
    ...item.data(),
    id: item.id,
    id_firebase: idLoja,
})).filter((item) => item.veexibir_site !== false);

export function assinarVeiculos(onChange, onError) {
    const snapshots = new Map();
    const publicar = () => {
        const veiculos = [...snapshots.values()]
            .flat()
            .sort((a, b) => (b.updated_at || 0) - (a.updated_at || 0));
        onChange(veiculos);
    };

    const unsubscribes = ids_firebase.map((idLoja) => onSnapshot(
        veiculosQuery(idLoja),
        (snapshot) => {
            snapshots.set(idLoja, normalizarSnapshot(snapshot, idLoja));
            publicar();
        },
        onError
    ));

    return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}

export async function buscarVeiculo(idVeiculo, idLoja) {
    const lojas = idLoja ? [idLoja] : ids_firebase;

    for (const loja of lojas) {
        const snapshot = await getDoc(doc(veiculosCollection(loja), idVeiculo));
        if (snapshot.exists()) {
            return { ...snapshot.data(), id: snapshot.id, id_firebase: loja };
        }
    }

    return null;
}
